import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { GetLogMessagesFiltered$Params } from 'src/app/server-api/fn/log-message-controller/get-log-messages-filtered';
import { LogMessageFilterDto } from 'src/app/server-api/models';
import { LogMessageControllerService } from 'src/app/server-api/services';
import { ListComponent } from 'src/app/utils-flc/list/list.component';
import { LogMessagesService } from '../log-messages.service';

@Component({
  selector: 'app-log-messages-list',
  templateUrl: './log-messages-list.component.html',
  styleUrls: ['./log-messages-list.component.css']
})
export class LogMessagesListComponent extends ListComponent
{
  reloadSubscription: Subscription;

  @Input() modelId: string = '';
  showningId: string;

 constructor(public override translate: TranslateService, public override sidenavService: SideNavService, private logService: LogMessageControllerService,
  private logMessagesService: LogMessagesService
   ) {
     super(translate, sidenavService);

     this.constructorName = 'LogMessagesList';
     this.primarySort.active = 'created';
     this.defaultSort.active = 'created';
   }

 override ngOnInit(): void {

   this.placeholderSearchText = 'log-message.search';
   this.exportPrefix = 'log-messages_';
   this.primarySort.active = 'created';
   this.primarySort.direction = 'desc';
   this.defaultSort.active = 'created';
   this.defaultSort.direction = 'desc';

   super.ngOnInit();
  }

  ngOnChanges() {
    //to refresh list when modelId changes, not first time, automatically
    if (!this.showningId)
    {
      this.showningId = this.modelId;
      return;
    }

    this.showningId = this.modelId;
    this.refresh();
  }

  override initAfterRoutePath()
  {
    this.translate
     .get([ 'icon_refresh', 'action_show', 'log-message.message-model', 'log-message.model-id'
   ])
     .subscribe((translations: string[]) => {
      this.translations = translations;
       this.topMenuIcons = [
         //{icon: "add", title: translations['tunnel_section.button_create'], routerLink: RouterLinkEnum.TUNNEL_SECTIONS.toString() + "new", clickMethod: "dummy"},
         {icon: "refresh", title: translations['icon_refresh'], routerLink: null, clickMethod: "refresh"}
       ];
       this.actions = [
         {icon: "playlist_add", title: translations['action_show'], routerLink: RouterLinkEnum.LOG_MESSAGES.toString(), clickMethod: "dummy"}
       ];

       if (this.modelId && this.modelId.length > 0)
       {
        this.displayedColumns = ['actions', 'lastModificationDate', 'author', 'subject', 'startChainage', 'body'];
        this.defaultPageSize = 5;
        this.filterFields = [''];
       }
       else
       {
         this.displayedColumns = ['actions', 'lastModificationDate', 'author', 'subject', 'messageModel', 'modelId', 'startChainage', 'body'];
         this.filterFields = ['', translations['log-message.message-model'], translations['log-message.model-id']];
       }

       this.constructorName = this.modelId ? this.constructorName + '-' + this.modelId : this.constructorName;
     });


  }

 override ngOnDestroy(): void {
   super.ngOnDestroy();
   if (this.reloadSubscription) this.reloadSubscription.unsubscribe();
 }


 override getItems() {
   super.getItems();

   let filterRequest: string = this.filter ? this.filter.nativeElement.value : '';
   let bodyRequest:LogMessageFilterDto = {  };
    for (let filter of this.filters)
    {
       if (filter.field === '') filterRequest = filter.value;
       if (filter.field === this.translations['log-message.message-model']) bodyRequest.messageModel = filter.value;
       if (filter.field === this.translations['log-message.model-id']) bodyRequest.modelId = filter.value;
    }
    if (this.modelId && this.modelId.length > 0)
      bodyRequest.modelId = this.modelId;

    let request:GetLogMessagesFiltered$Params = {
      page: this.paginator.pageIndex,
      size: this.paginator.pageSize,
      sort: [this.dataSource.sort.active + ',' + this.dataSource.sort.direction],
      filter: filterRequest,
      body: bodyRequest
    };

   this.logService.getLogMessagesFiltered(request).subscribe(
         value  => {
       this.dataSource.data = value['content'];
       this.listIds = this.dataSource.data.map(d => d.id);
       this.totalElements = value['totalElements'];
       this.sidenavService.setLoading(false);
     }
   ,
     error => {
       console.error(JSON.stringify(error));
       this.sidenavService.setLoading(false);
     }
       ,
     () => {
       this.sidenavService.setLoading(false);
     }
   );
 }

  override clickedRow(id: string): void {
    super.clickedRow(id);
    this.logMessagesService.selectMessageOnMap(this.clickedRowId);
  }

}
